import React from "react";
import { Reveal } from "./Reveal";

export function PageHero({ overline, title, subtitle }) {
  return (
    <section className="stone-panel border-b border-taupe/30">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-20 sm:py-28 text-center">
        <Reveal>
          {overline && <p className="overline text-olive mb-5">{overline}</p>}
          <h1 className="font-serif text-5xl sm:text-6xl lg:text-7xl leading-[0.95] text-matte">{title}</h1>
          <div className="gold-line mx-auto mt-8" />
          {subtitle && <p className="mt-6 max-w-2xl mx-auto text-taupe text-base sm:text-lg">{subtitle}</p>}
        </Reveal>
      </div>
    </section>
  );
}
